import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { apiJson } from "../../utils/api";
import useSeo from "../../hooks/useSeo";
import { Disclaimer } from "../marriage/MarriageLayout";

export default function WeddingServices() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "";
  const [city, setCity] = useState("");
  const [data, setData] = useState({ items: [], categories: [] });

  useSeo({
    title: "婚礼服务 | 摄影·婚宴·婚房·蜜月",
    metaDescription: "婚礼策划、婚纱摄影、婚宴、婚房与蜜月旅行导流。这些商家不能办理法律意义上的结婚登记。",
    path: "/wedding",
  });

  useEffect(() => {
    const q = new URLSearchParams();
    if (cat) q.set("category", cat);
    if (city) q.set("city", city);
    apiJson(`/api/wedding/vendors?${q.toString()}`).then(({ data: d }) => setData(d));
  }, [cat, city]);

  const title = useMemo(() => {
    const hit = (data.categories || []).find((c) => c.key === cat);
    return hit ? hit.label : "婚礼服务";
  }, [cat, data.categories]);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-extrabold">🎉 {title}</h1>
      <Disclaimer />
      <div className="flex flex-wrap gap-2">
        <button
          className={`px-3 py-1.5 rounded-full text-sm border ${!cat ? "bg-rose-500 text-white border-rose-500" : "bg-white"}`}
          onClick={() => setParams({})}
        >
          全部
        </button>
        {(data.categories || []).map((item) => (
          <button
            key={item.key}
            className={`px-3 py-1.5 rounded-full text-sm border ${cat === item.key ? "bg-rose-500 text-white border-rose-500" : "bg-white"}`}
            onClick={() => setParams({ cat: item.key })}
          >
            {item.label}
          </button>
        ))}
        <input
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="城市筛选"
          className="border rounded-full px-3 py-1.5 text-sm"
        />
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {(data.items || []).map((item) => (
          <article key={item.id} className="bg-white rounded-2xl p-5 border">
            <div className="flex justify-between gap-2">
              <h2 className="font-bold">{item.name}</h2>
              <span className="text-xs text-gray-500">{item.category_label}</span>
            </div>
            <p className="text-sm text-gray-600 mt-2">{item.city} {item.district}</p>
            <p className="text-sm mt-2">{item.intro}</p>
            <p className="text-xs text-rose-700 mt-2">{item.legal_label}</p>
            <p className="text-sm mt-2">咨询：{item.phone}</p>
          </article>
        ))}
      </div>
      {!data.items?.length ? <p className="text-gray-400">该城市暂无示例商家，可换杭州/九江/三亚试试。</p> : null}
    </div>
  );
}
